import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import FeedIcon from '@mui/icons-material/Feed';
import FlaggedPostsManager from './FlaggedPostsManager';
import PostsManager from './PostsManager';

const Moderation = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Paper sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          aria-label="moderation tabs"
          className='tabs'
          sx={{ backgroundColor: '#f5f5f5' }}
        >
          <Tab
            label="All Posts"
            icon={<FeedIcon />}
            iconPosition="start"
            sx={{ minWidth: 200 }}
          />
          <Tab
            label="Flagged Posts"
            icon={<FlagIcon />}
            iconPosition="start"
            sx={{ minWidth: 200 }}
          />
        </Tabs>
      </Paper>

      <Box>
        {currentTab === 0 && <PostsManager />}
        {currentTab === 1 && <FlaggedPostsManager />}
      </Box>
    </Box>
  );
};

export default Moderation;
